export default 'Authorization';
